import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitConnection } from '@/services/git/api';
import type { GitConnection } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitConnection(): UseQueryResult<GitConnection | null, Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitConnection', orgId],
    queryFn: () => fetchGitConnection(orgId!),
    enabled: !!token && !!orgId,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
}
